var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { Defaults } from "../../../defaults";
import moment from "moment";
export class Usuarios {
    initDatatable() {
        $('table').DataTable({
            ajax: {
                url: 'user/list',
                dataSrc: Defaults.global.dt.ajax.dataSrc('users')
            },
            columnDefs: Defaults.global.dt.getColumns([
                {
                    title: 'Nombre',
                    data: 'name'
                },
                {
                    title: 'Correo Electrónico',
                    data: 'email'
                },
                {
                    title: 'Ultimo Inicio de Sesión',
                    data: 'last_login',
                    render: (data, type) => {
                        if (type === 'display') {
                            return data ? moment(data).format('DD/MM/YYYY h:mma') : '-';
                        }
                        return data;
                    }
                },
                {
                    orderable: false,
                    render: (_, type, { id }) => type === 'display'
                        ? `<button type="button" class="delete-user btn btn-xs btn-danger" data-id="${id}" title="Eliminar usuario">
                               <i class="material-icons">delete</i>
                           </button>`
                        : null
                }
            ])
        });
    }
    deleteUser(id) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!confirm('¿Eliminar este usuario? Esta acción no se puede deshacer.')) {
                return;
            }
            yield $.ajax({ url: 'user/data/' + id, method: 'delete' });
            $('table').DataTable().ajax.reload(null, false);
        });
    }
}
